// * Header Sticky
      function headerSticky() {
      let lastScrollTop = 0;
      const header = document.querySelector('.header__inner_home');
      if (!header) return;
      window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;

        if (currentScroll > 100) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');
       
        if (currentScroll === 0) header.style.transform = 'translateY(0)';
        else if (currentScroll < lastScrollTop) header.style.transform = 'translateY(0)';
        else header.style.transform = 'translateY(-100%)';
        lastScrollTop = currentScroll;
      });
    }
    headerSticky();



// scroll-animation start
document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".scroll-animation");

    function checkScroll() {
        elements.forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.85) {
                element.classList.add("visible");
            }
        });
    }

    window.addEventListener("scroll", checkScroll);
    checkScroll(); // Run on load in case elements are already in view
});




// scroll-animation end





// Mobile menu start


$(".header__mobi-left").on("click", function () {
    $(this).toggleClass("active");
    $(".header__mobi-menu").toggleClass('active');
    $("body").toggleClass("mobile__menu-open");
});


// Mobile menu end



// ================= Header Sticky & Hide/Show on Scroll start =================


// let lastScroll = 0;
// const header = document.querySelector('.header');

// window.addEventListener('scroll', () => {
//     const currentScroll = window.pageYOffset;

//     if (currentScroll > lastScroll && currentScroll > 50) {
//         // scrolling down
//         header.classList.add('hide');
//     } else {
//         // scrolling up
//         header.classList.remove('hide');
//     }

//     lastScroll = currentScroll;
// });


// ================= Header Sticky & Hide/Show on Scroll end =================


// hero start


// if ($(Window).width() < 768) {
//     $('.hero__wrapper').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//     });
// }



// hero end



// product-cards start




var $status = $('.best-sellers__slider-num');
var $slickElement = $('.product-cards_slider');
var $leftArrow = $('.best-sellers__left-arrow');
var $rightArrow = $('.best-sellers__right-arrow');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
    var i = (typeof currentSlide === 'number' ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);

    // Reset both
    $leftArrow.removeClass('disabled');
    $rightArrow.removeClass('disabled');

    if (i === 1) {
        $leftArrow.addClass('disabled');
    } else if (i === slick.slideCount) {
        $rightArrow.addClass('disabled');
    }
});

// Slick init
if ($(window).width() < 768) {
    $slickElement.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}







$('.best-sellers__left-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.best-sellers__right-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});




// product-cards end




// collection-product start




document.querySelectorAll('.custom-select').forEach(select => {
    const trigger = select.querySelector('.custom-select__trigger');
    const options = select.querySelectorAll('.custom-option');
    const span = trigger.querySelector('span');

    trigger.addEventListener('click', () => {
        select.classList.toggle('open');
    });

    options.forEach(option => {
        option.addEventListener('click', () => {
            span.textContent = option.textContent;
            select.classList.remove('open');
        });
    });
});

// Close dropdown if clicked outside
window.addEventListener('click', e => {
    document.querySelectorAll('.custom-select').forEach(select => {
        if (!select.contains(e.target)) {
            select.classList.remove('open');
        }
    });
});




// collection-product end


// gallery start


$(".gallery__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});



// gallery end




// faq start



$(".accordion__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion__content").slideUp();
    } else {
        $(".accordion__content").slideUp();
        $(".accordion__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion__content").slideDown();
    }
})



// faq end



// product start


if ($(Window).width() < 1024) {
    $('.sharper__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinity: true,
    });
}
$(document).on('click', '.sharper-arrow-next', function () {
    $(this).closest('.sharper').find('.sharper__items').slick('slickNext');
});
$(document).ready(function () {
    function handleVideoBehavior() {
        var windowWidth = $(window).width();
        $(".sharper__item video").each(function () {
            this.pause();
            this.currentTime = 0;
        });
        if (windowWidth <= 1024) {
            $(".sharper__item video").each(function () {
                this.play();
            });
            $(".sharper__item").off("mouseenter mouseleave");
        } else {
            $(".sharper__item").off("mouseenter mouseleave").on("mouseenter", function () {
                $(this).find("video").get(0).play();
            }).on("mouseleave", function () {
                var video = $(this).find("video").get(0);
                video.pause();
                video.currentTime = 0;
            });
        }
    }
    handleVideoBehavior();
    $(window).on("resize", function () {
        handleVideoBehavior();
    });


    if ($(Window).width() > 768) {
        setTimeout(function () {
            var left_height = $('.product__left').height();
            var right_height = $('.product__right').height();
            // console.log(left_height);
            if (left_height > right_height) {
                $('.product__wrapper').height(left_height);
            }
            else {
                $('.product__wrapper').height(right_height);
            }
        }, 500); // 500 milliseconds = 5 seconds
    }



});
$(document).ready(function () {
    var $slider = $('.product__left-items');
    var $counter = $('.slick-counter');
    $slider.on('init', function (event, slick) {
        $counter.find('.slick-total').text(slick.slideCount);
        $counter.find('.slick-current').text(1);
    });
    $slider.on('afterChange', function (event, slick, currentSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $counter.find('.slick-current').text(i);
    });
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        dots: true,
    });
});
$(document).on('click', '.product-left-arrow-next', function () {
    $(this).closest('.product').find('.product__left-items').slick('slickPrev');
});
$(document).on('click', '.product-right-arrow-prev', function () {
    $(this).closest('.product').find('.product__left-items').slick('slickNext');
});






// product end



// like start


if ($(Window).width() < 768) {
    $('.like__inner .product-cards').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
    });
}


// like end




// popup start




$(function () {
    let i = 0,
        tx = 0, ty = 0, sx, sy, dragging = false,
        scale = 1,
        $popup = $('.popup'),
        $img = $('.popup__img img'),
        $video = $('.popup__img video'),
        $current = $('.popup .slick-current'),
        $total = $('.popup .slick-total'),
        $items = $('.product__left-item:not(.slick-cloned)'); // only real items

    $total.text($items.length);

    function activeEl() { return $img.is(':visible') ? $img : $video; }

    function reset() {
        tx = 0;
        ty = 0;
        scale = 1;
        activeEl().css('transform', 'translate(0,0) scale(1)');
    }

    function show(i) {
        const $item = $items.eq(i),
            $itemImg = $item.find('img'),
            $itemVideo = $item.find('video');

        if ($itemImg.length) {
            $img.attr('src', $itemImg.attr('src')).show();
            $video.hide().get(0).pause();
        } else if ($itemVideo.length) {
            $video.attr('src', $itemVideo.find('source').attr('src')).show().get(0).play();
            $img.hide();
        }

        $current.text(i + 1);
        reset(); // reset position & scale on show
    }

    // Click on items to open popup
    $items.click(function () {
        i = $(this).data('slick-index');
        show(i);
        $popup.show();
        $('body').addClass('popup-open');
    });

    // Close popup
    $('.popup__close').click(() => {
        $popup.hide();
        $video.get(0).pause();
        $('body').removeClass('popup-open zoom-active');
    });

    // Next / Previous arrows
    $('.popup-right-arrow-prev').click(() => show(i = (i + 1) % $items.length));
    $('.popup-left-arrow-next').click(() => show(i = (i - 1 + $items.length) % $items.length));

    // Zoom button (scale)
    $('.popup__img-zoom').click(() => {
        const $el = activeEl();
        if ($popup.hasClass('zoom-active')) {
            // Zoom off → reset position
            $popup.removeClass('zoom-active');
            scale = 1;
            tx = 0; ty = 0;
            $el.css('transform', `translate(${tx}px,${ty}px) scale(${scale})`);
        } else {
            // Zoom on
            $popup.addClass('zoom-active');
            scale = 1.5; // zoom in scale
            $el.css('transform', `translate(${tx}px,${ty}px) scale(${scale})`);
        }
    });

    // Drag with mouse while holding
    $('.popup__img').on('mousedown', e => {
        if (!$popup.hasClass('zoom-active')) return;
        e.preventDefault();
        dragging = true;
        sx = e.clientX - tx;
        sy = e.clientY - ty;
    });

    $(document).on('mousemove', e => {
        if (!dragging) return;

        const $el = activeEl(),
            container = $('.popup__img')[0].getBoundingClientRect(),
            media = $el[0].getBoundingClientRect();

        let newX = e.clientX - sx,
            newY = e.clientY - sy;

        // Bounding inside container
        let maxX = (media.width - container.width) / 2,
            maxY = (media.height - container.height) / 2;

        tx = Math.min(maxX, Math.max(-maxX, newX));
        ty = Math.min(maxY, Math.max(-maxY, newY));

        $el.css('transform', `translate(${tx}px,${ty}px) scale(${scale})`);
    }).on('mouseup', () => {
        dragging = false;
    });
});






// popup end



// if ($(Window).width() > 768) {
//     setTimeout(function () {
//         var left_height = $('.hero').height();
//         var right_height = $('.collection-extra-wrapper').height();
//         if (left_height > right_height) {
//             $('.collection-extra').height(left_height);
//         }
//         else {
//             $('.collection-extra').height(right_height);
//         }
//     }, 500); // 500 milliseconds = 5 seconds
// }




$(document).ready(function () {
  /* ================================
     Tab Area Button Click Handling
     ================================ */
  $(".tab-area__btn").click(function (e) {
    e.preventDefault();

    // Get target tab number
    var tabId = $(this).data("tab");

    // Update active button
    $(".tab-area__btn").removeClass("tab-area__btn_active");
    $(this).addClass("tab-area__btn_active");

    // Right content fade handling
    $(".tab-area__right-item-wrap")
      .removeClass("tab-area__right-item-wrap_active")
      .hide();
    $('.tab-area__right-item-wrap[data-tab-content="' + tabId + '"]')
      .fadeIn(0)
      .addClass("tab-area__right-item-wrap_active");

    // Left content fade handling
    $(".tab-arae__left-item")
      .removeClass("tab-arae__left-item_active")
      .hide();
    $('.tab-arae__left-item[data-tab-content="' + tabId + '"]')
      .fadeIn(0)
      .addClass("tab-arae__left-item_active");
  });

  /* ================================
     Tab Area Image Button Click Handling
     ================================ */
  $(document).on("click", ".tab-area-img-btn", function (e) {
    e.preventDefault();

    // Get clicked tab number
    var tabId = $(this).data("img-tab");
    // var product_url = $(this).attr("href");

    // Remove active class from all small buttons
    $(".tab-area-img-btn").removeClass("tab-area-img-btn_active");

    // Add active class to clicked button
    $(this).addClass("tab-area-img-btn_active");

    // Remove active class from all big images
    $(".tab-area__display-img").removeClass("tab-area__display-img_active");

    // Add active class to corresponding big image
    $('.tab-area__display-img[data-img-content-tab="' + tabId + '"]')
      .addClass("tab-area__display-img_active");
  });

  /* ================================
     Megamenu Slider Initialization
     ================================ */
  $(".megamenu__items").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false
  });

  // Megamenu slider navigation buttons
  $(".megamenu-slider-arrow-next").click(function () {
    $(this).parent().parent().find(".slick-slider").slick("slickPrev");
  });
  $(".megamenu-slider-arrow-prev").click(function () {
    $(this).parent().parent().find(".slick-slider").slick("slickNext");
  });

  /* ================================
     Arrival Area Slider Initialization
     ================================ */
  $(".arrival-area__items").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Arrival area slider navigation buttons
  $(".arrival-area__slider-arrow-next").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickPrev");
  });
  $(".arrival-area__slider-arrow-prev").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickNext");
  });

  /* ================================
     Header Hover & Scroll Effect
     ================================ */
  $(".header__inner_home").hover(
    function () {
      if ($(window).scrollTop() < 100) {
        $(".header__inner_home").addClass("header__inner_hove-active");
      }
    },
    function () {
      if ($(window).scrollTop() < 100) {
        $(".header__inner_home").removeClass("header__inner_hove-active");
      }
    }
  );

  // $(window).on("scroll", function () {
  //   if ($(this).scrollTop() >= 100) {
  //     $(".header__inner_home").addClass("header__inner_hove-active");
  //   } else {
  //     $(".header__inner_home").removeClass("header__inner_hove-active");
  //   }
  // });

  /* ================================
     Hero Area Slider Initialization
     ================================ */
var $slider = $(".hero-area__items");

$slider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  speed: 1000,
});

/* Hero Area Slider Button Click Handling */
$(".hero-area__slider-btn").on("click", function (e) {
  e.preventDefault();

  var index = $(this).index(".hero-area__slider-btn");

  // Go to corresponding slide
  $slider.slick("slickGoTo", index);

  // Update active button
  $(".hero-area__slider-btn").removeClass("hero-area__slider-btn_active");
  $(this).addClass("hero-area__slider-btn_active");
});

/* Update active button on slider change */
$slider.on("afterChange", function (event, slick, currentSlide) {
  $(".hero-area__slider-btn").removeClass("hero-area__slider-btn_active");
  $(".hero-area__slider-btn").eq(currentSlide).addClass("hero-area__slider-btn_active");

  // Remove hover-up from all slides if current/active changes
  $(".hero-area__items .slick-slide").removeClass("hover-up");
});

/* Hero Area Slider Button Hover Effect */
$(".hero-area__slider-btn").hover(
  function () {
    // Skip if hovered button is already active
    if ($(this).hasClass("hero-area__slider-btn_active")) return;

    var currentIndex = $(".hero-area__slider-btn_active").index(".hero-area__slider-btn");
    var nextIndex = currentIndex + 1;

    // Highlight next slide on hover
    var $nextSlide = $(".hero-area__items .slick-slide[data-slick-index='" + nextIndex + "']");

    // Add hover-up only if not current or active
    if (!$nextSlide.hasClass("slick-current") && !$nextSlide.hasClass("slick-active")) {
      $nextSlide.addClass("hover-up");
    }
  },
  function () {
    $(".hero-area__items .slick-slide").removeClass("hover-up");
  }
);

// Extra: Remove hover-up if slick-current or slick-active appears dynamically
$slider.on("afterChange init reInit", function () {
  $(".hero-area__items .slick-slide").each(function () {
    if ($(this).hasClass("slick-current") || $(this).hasClass("slick-active")) {
      $(this).removeClass("hover-up");
    }
  });
});



      $(".header__cart a").on('click', function (e) {
        e.preventDefault();
        $("body").addClass('cart-drawer-open');
      });

      $(document).on('click', '.cart-drawer__close , .overlay', function (e) {
        e.preventDefault();
        $("body").removeClass('cart-drawer-open');
      });





document.addEventListener("click", (e) => {
  if (!e.target.closest(".dropdown")) {
    document.querySelectorAll(".dropdown-menu").forEach(m => {
      m.style.display = "none";
    });
  }
});





  if ($(Window).width() < 768) {
    $('.cart-drawer__collection .product-cards').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
    });
}

});


$('.hero-area__bg').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    fade: true,
    adaptiveHeight: true,
    // asNavFor: '.hero-area__slide-text-wrap'
});
// $('.hero-area__slide-text-wrap').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: false,
//     asNavFor: '.hero-area__bg',
//     focusOnSelect: true
// });


// Navigation click
$('.hero-area__slide-text ').on('click', function(e){
  e.preventDefault();
  var slideIndex = $(this).data('slide');
  $('.hero-area__slide-text ').removeClass('active');
  $(this).addClass('active');
  
  // force slick to jump directly with animation
  $('.hero-area__bg').slick('slickGoTo', slideIndex, false);
});

$('.header__search a').click(function(e){
    e.preventDefault();
    $('body').toggleClass('search-open');
});
$('.search-bar__close').click(function(e){
    $('body').removeClass('search-open');
})



$(".header__mobi-menu").on('click' , function(e) {
  // e.stopPropagation()
    $('body').toggleClass('mobile-menu-open');
    $('.header__inner').addClass('header__inner_hove-active');
});
$(".menu__has-menu").on('click' , function(e) {
  e.preventDefault();
    $('.menu__sub-menu').addClass('menu-sub-menu-active');
    $('.header__inner').addClass('header__inner_hove-active');
});
$(".menu__sub-menu-back").on('click' , function() {
    $('.menu__sub-menu').removeClass('menu-sub-menu-active');
});
$(".menu").on('click' , function() {
    $('.header__inner').addClass('header__inner_hove-active');
});







$(document).on('click', 'a[href^="#"]', function(e) {
  e.preventDefault();
  var target = $(this).attr('href');
  var $target = $(target);

  if ($target.length) {
    $('html, body').animate({
      scrollTop: $target.offset().top
    }, 600); // adjust 600 for faster/slower scroll
  }
});







